import useApi from "../useApi";


const useBookableService = () => {

  const {api} = useApi()

  const show = (callbackSuccess, callbackValidationErrors, callbackSwal, filter) => {
    return api(
      'post',
      'bookable/filtered/',
      response => callbackSuccess(response.data),
      callbackValidationErrors,
      error => {throw new Error(`Error in useBookableService::show: ${error?.message || JSON.stringify(error)}`)},
      filter,
      true,
      callbackSwal,
    )
  }

  const showBookableMonthBookings = (callbackSuccess, callbackValidationErrors, objectType, bookableIds, month, selectedDates) => {
    return api(
      'post',
      'bookable/month-bookings/',
      response => callbackSuccess(response.data),
      callbackValidationErrors,
      error => {throw new Error(`Error in useBookableService::showBookableMonthBookings: ${error?.message || JSON.stringify(error)}`)},
      {
        object_type: objectType, //stand, spot_group, bookables
        bookable_ids: bookableIds,
        month: month,
        selected_dates: selectedDates
      },
      true,
    )
  }

  const showBookableRangeBookings = (callbackSuccess, callbackValidationErrors, objectType, bookableId, startDate, endDate) => {
    return api(
      'post',
      'user/bookable/range-bookings/',
      response => callbackSuccess(response.data),
      callbackValidationErrors,
      error => {throw new Error(`Error in useBookableService::showBookableRangeBookings: ${error?.message || JSON.stringify(error)}`)},
      {
        object_type: objectType, //stand, spot_group, bookables
        bookable_id: bookableId,
        start_date: startDate,
        end_date: endDate,
      },
      true,
    )
  }

  return {
    show,
    showBookableMonthBookings,
    showBookableRangeBookings,
  }
}


export default useBookableService
